export default __webpack_public_path__ + "static/N0300-9f1cf3a68cf892e327865ba814bd2df6.png";